import React from "react";

export const REPORTS_HELP_TITLE = "Relatórios";

export function ReportsHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> O menu <strong>Relatórios</strong>{" "}
        reúne resumos prontos para o escritório: horas das máquinas e o que
        foi trabalhado em cada talhão. Use para conferir o mês e para
        imprimir ou exportar.
      </p>

      <p>
        <strong>O que fazer em cada relatório:</strong>
      </p>
      <ul>
        <li>
          <strong>Máquinas</strong> — escolha o mês e o ano. Cada cartão
          mostra horas ligadas, trabalhadas e ociosas daquela máquina, além
          das atividades do período. Serve para acompanhar o uso da frota.
        </li>
        <li>
          <strong>Por seção</strong> — escolha os talhões (seções), as
          máquinas e os operadores, e o intervalo de datas. A plataforma
          mostra o trabalho em cada área do mapa.
        </li>
      </ul>

      <p>
        <strong>Quando usar:</strong> no fechamento da semana ou do mês, ou
        quando o gestor precisa de um número de horas por máquina ou por
        talhão. Para o detalhe do dia a dia (mapa, turno e abastecimento),
        use o <strong>App de Campo</strong>.
      </p>
    </>
  );
}
